import * as yup from 'yup';

export const ApplyJobpostSchema = yup.object().shape({
  introduction: yup.string().required('Introductions is required').max(3000),
  jobpostId: yup.string().required(),
});
